import { BookOpenCheck, ChevronLeft, Clock, MessageCircleQuestion, Minus, Plus } from "lucide-react";
import { useEffect, useState } from "react";
import QuestionRichContent from "./QuestionRichContent";

const MockTestQuestionPaper=({setQuestionPaperVisible,
    responseArray,sectionsArr,currentSection,sectionStatsAll,mockTestCard1Object,setQuestionsArr,questionsArrDummy,
    setCurrentSection,setCurrentSectionIndex,currentSectionIndex,setCurrentQuestionIndex,setCurrentQuestionObject,
    SetQuestionVisited,setLoadSections,handleQuestionClick
})=>{

   const ImageFallFB = ({ itemOuter,boxShadow,src,width,aspectRatio, borderRadius,border,paddingLeft,paddingRight}) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [hasError, setHasError] = useState(false);
    
       
            
                 
    return (
     
        <img
  
        
          src={ src}
          alt=""
         style={
               {
                 
        top: 0,
        left: 0,
        width: `${width}px`,
       
        objectFit: "cover", }}
         className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
        />
      
    );
  };
  
    const getQuestionsFromOneSection = (questionsArrAll, secQuestionsIDArr) => { 
  let secQuestions = [];

  try {
    secQuestions = Array.isArray(secQuestionsIDArr)
      ? secQuestionsIDArr
      : JSON.parse(secQuestionsIDArr || '[]');
  } catch (e) {
    console.warn("Invalid JSON in secQuestions", e);
    return [];
  }

  // Map of all available questions by ID for fast lookup
  const questionMap = new Map();
  questionsArrAll?.forEach(q => questionMap.set(q?.ID, q));

  // Preserve the order from secQuestions
  return secQuestions
    .map(q => questionMap.get(q?.ID))
    .filter(Boolean); // remove undefined if any ID is not found
};
  const [quesFromSections ,setQuesFromSections] =useState([])
//   useEffect(()=>{
//     setQuesFromSections(getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex]?.secQuestions));
//     // console.log(sectionsArr[currentSectionIndex]?.secQuestions)
//     // console.log(questionsArrDummy)
//     // console.log(getQuestionsFromOneSection(questionsArrDummy,sectionsArr[currentSectionIndex]?.secQuestions))
//   },[currentSection?.secQuestions])
  

  const formatTime = (seconds) => {
    const hrs = String(Math.floor(seconds / 3600)).padStart(2, '0');
    const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
    const secs = String(seconds % 60).padStart(2, '0');
    return `${hrs}:${mins}:${secs}`;
  };
  
    const getTimerByActiveID = ( activeID) => {
  const question = responseArray.find(q => q.ID === activeID);
  return question ? question.timer : 0;
};
  const formatTimeQue = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return hours?[
    hours.toString().padStart(2, '0'),
    minutes.toString().padStart(2, '0'),
    seconds.toString().padStart(2, '0'),
  ].join(':'):[
   
    minutes.toString().padStart(2, '0'),
    seconds.toString().padStart(2, '0'),
  ].join(':');
};
  
  return(<>
    
    <div>
       <div className="palletMockTopV1Title">
  
    <div onClick={()=>{setQuestionPaperVisible(true);}}  style={{border:"2px solid #888",width:"80px",borderRadius:"5px",height:"40px",display:"flex",justifyContent:"center",alignItems:"center",margin:"5px",marginTop:"10px",fontWeight:"999",fontSize:"14px"}}><div   className="palletGridList" style={{background:"#fff"}}><ChevronLeft style={{position:"relative"}}   color={"#333"} size={20}/></div><div className="mockTestTagsFont">Back</div></div>
     <div  className="mockTestTitleFont" style={{fontSize:"19px",padding:"5px",fontWeight:"999",}}>Question Paper </div> </div>
    
    <div className="QPMockPalletInfo" style={{}}>
  
  <div className="palletInfoBtn"> <div className="palletNotAttempdedButtonSmall" 
     style={{background:"#ddd",color:"#333"}}
     ><Clock size={20} color={mockTestCard1Object?.questionTimer?.iconColor?.color}/></div>
         <div className="palletInfoTitle mockTestTagsFont">Total Time Spent:  {sectionStatsAll?.timeSpent?formatTime(sectionStatsAll?.timeSpent):formatTime(0)}</div> 
    </div>
   <div className="palletInfoBtn"> <div className="palletNotAttempdedButtonSmall" 
     style={{background:"#ddd",color:"#333"}}
     >{sectionStatsAll?.notVisited}</div>
         <div className="palletInfoTitle mockTestTagsFont"> Not Visited</div> 
    </div><div className="palletInfoBtn">
        <div className="palletAttempdedButtonSmall" 
     style={{}}
     >{  sectionStatsAll?.answered}</div>    <div className="palletInfoTitle mockTestTagsFont"> Answered</div> 
    </div><div className="palletInfoBtn">
       <div className="palletNotAttempdedButtonSmall" 
     style={{}}
     >{sectionStatsAll?.visited}</div>   <div className="palletInfoTitle mockTestTagsFont"> Not Answered</div> 
    </div>
     <div className="palletInfoBtn">
       <div className="palletNotAttempdedButtonSmall" 
     style={{}}
     ><div className="palletAttempdedButtonInnSmall"  style={{}}
     ></div>{sectionStatsAll?.markedAndNotAnswered}</div>
       <div className="palletInfoTitle mockTestTagsFont"> Not Answered And Marked</div> 
    </div><div className="palletInfoBtn">
       <div className="palletAttempdedButtonSmall" 
     style={{}}
     ><div className="palletAttempdedButtonInnSmall"  style={{}}
     ></div>{sectionStatsAll?.markedAndAnswered}</div>    <div className="palletInfoTitle mockTestTagsFont"> Answered And Marked</div> 
    </div>
  </div>



 {sectionsArr?.map((item,indexSec) =>(
          <div  key={item?.ID || indexSec}  
           >
            <div style={{display:"flex",justifyContent:"left"}}>
           
              <div className="mockTestButtonFont" style={{fontSize:"19px",padding:"5px",fontWeight:"999",marginTop:"5px"}}> Section:{indexSec+1} </div> 
        { 
        
        
        
        <div onClick={()=>{setQuestionsArr(getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions));setCurrentSection(item);
             setCurrentSectionIndex(indexSec);setCurrentQuestionIndex(0);
               setCurrentQuestionObject(getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions).length?getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions)[0]:[])
                 SetQuestionVisited(getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions).length?getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions)[0]:[],"visited");
           
               setLoadSections(false); setTimeout(()=>{ setLoadSections(true); },0);
                handleQuestionClick(getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions).length?getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions)[0]?.ID:"");
          }}
        
        className= {`quizSectionMoreItem ${item?.ID===currentSection?.ID?"activeQuizSection":""} `} style={{}}> <div className="ellipsisTitleQuiz mockTestButtonFont" style={{width:" 120px",}}>  {item?.sectionName} </div>
        <div className="quizSectionMoreItemInn" >
            <div className="palletInfoTitle mockTestTitleFont">  {item?.sectionName}</div>   
       <div className="palletInfoBtn"> <div className="palletNotAttempdedButtonSmall" 
     style={{}} ><Clock size={20} color={mockTestCard1Object?.questionTimer?.iconColor?.color}/>
     </div>
         <div className="palletInfoTitle mockTestTitleFont"> Time Spent: {sectionsArr[indexSec]?.sectionStats?.timeSpent?formatTime(sectionsArr[indexSec]?.sectionStats?.timeSpent):formatTime(0)}</div> 
    </div> <div className="palletInfoBtn"> <div className="palletNotAttempdedButtonSmall" 
     style={{background:"#ddd",color:"#333"}}
     >{sectionsArr[indexSec]?.sectionStats?.notVisited}</div>
         <div className="palletInfoTitle mockTestSubTitleFont"> Not Visited</div> 
    </div><div className="palletInfoBtn">
        <div className="palletAttempdedButtonSmall" 
     style={{}}
     >{sectionsArr[indexSec]?.sectionStats?.answered}</div>    <div className="palletInfoTitle mockTestSubTitleFont"> Answered</div> 
    </div><div className="palletInfoBtn">
       <div className="palletNotAttempdedButtonSmall" 
     style={{}}
     >{sectionsArr[indexSec]?.sectionStats?.visited}</div>   <div className="palletInfoTitle mockTestSubTitleFont"> Not Answered</div> 
    </div>
    <div className="palletInfoBtn">
       <div className="palletNotAttempdedButtonSmall" 
     style={{}}
     ><div className="palletAttempdedButtonInnSmall"  style={{}}
     ></div>{sectionsArr[indexSec]?.sectionStats?.markedAndNotAnswered}</div>
       <div className="palletInfoTitle mockTestSubTitleFont"> Not Answered And Marked</div> 
    </div><div className="palletInfoBtn">
       <div className="palletAttempdedButtonSmall" 
     style={{}}
     ><div className="palletAttempdedButtonInnSmall"  style={{}}
     ></div>{sectionsArr[indexSec]?.sectionStats?.markedAndAnswered}</div>    <div className="palletInfoTitle mockTestSubTitleFont"> Answered And Marked</div> 
    </div>
      </div>
      </div>}
      
      </div>

{
  // question Data Here
}

{getQuestionsFromOneSection(questionsArrDummy,sectionsArr[indexSec]?.secQuestions)?.length?getQuestionsFromOneSection(questionsArrDummy,sectionsArr[indexSec]?.secQuestions)?.map((itemQuestion, index) => 
        (
        <div  index={index} key={itemQuestion?.ID} 
        
          
        
        onClick={()=>{setCurrentQuestionObject(itemQuestion);SetQuestionVisited(itemQuestion,"visited");
          setCurrentQuestionIndex(index);
        handleQuestionClick(itemQuestion?.ID)
        setQuestionsArr(getQuestionsFromOneSection(questionsArrDummy,item?.secQuestions));setCurrentSection(item);
             setCurrentSectionIndex(indexSec);
                  
               setLoadSections(false); setTimeout(()=>{ setLoadSections(true); },0);
               
        
        }}  >
          <div>
           <div className=" palletAllButtonsBoxListQP " style={{margin:"10px",minHeight:"100px",background:`${mockTestCard1Object?.questionBoxCard?.bgColor?.color}`,
border:` ${mockTestCard1Object?.questionBoxCard?.border?.borderWidth?.value+mockTestCard1Object?.questionBoxCard?.border?.borderWidth?.resolution} ${mockTestCard1Object?.questionBoxCard?.border?.borderType}  ${mockTestCard1Object?.questionBoxCard?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${mockTestCard1Object?.questionBoxCard?.borderRadius?.topLeft?.value}${mockTestCard1Object?.questionBoxCard?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${mockTestCard1Object?.questionBoxCard?.borderRadius?.topRight?.value}${mockTestCard1Object?.questionBoxCard?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${mockTestCard1Object?.questionBoxCard?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.questionBoxCard?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${mockTestCard1Object?.questionBoxCard?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.questionBoxCard?.borderRadius?.bottomRight?.resolution}`,
}}>
    <div>  {(sectionsArr[indexSec]?.secQuestions[index]?.ID==itemQuestion?.ID)&&sectionsArr[indexSec]?.secQuestions[index]?.visited=="visited"&&sectionsArr[indexSec]?.secQuestions[index]?.answered!=="answered"&&sectionsArr[indexSec]?.secQuestions[index]?.marked!=="marked"?<div className="palletNotAttempdedButtonQP mockTestTagsFont" 
     style={{}}
     >{index<10?"0"+(index+1):(index+1)} Visited</div>
     :sectionsArr[indexSec]?.secQuestions[index]?.visited=="visited"&&sectionsArr[indexSec]?.secQuestions[index]?.answered=="answered"&&sectionsArr[indexSec]?.secQuestions[index]?.marked!=="marked"?<div className="palletAttempdedButtonQP mockTestTagsFont" 
     style={{}}
     ><div className="mockTestSubTitleFont" style={{marginTop:"10px"}}>{index<10?"0"+(index+1):(index+1)} Answered</div></div>
     :sectionsArr[indexSec]?.secQuestions[index]?.visited=="visited"&&sectionsArr[indexSec]?.secQuestions[index]?.answered!=="answered"&&sectionsArr[indexSec]?.secQuestions[index]?.marked=="marked"?
     <div className="palletNotAttempdedButtonQP mockTestTagsFont"   
     style={{}}
     ><div className="palletAttempdedButtonInnQP mockTestTagsFont"  style={{}}
     ></div>{index<10?"0"+(index+1):(index+1)} Marked</div>
     :sectionsArr[indexSec]?.secQuestions[index]?.visited=="visited"&&sectionsArr[indexSec]?.secQuestions[index]?.answered=="answered"&&sectionsArr[indexSec]?.secQuestions[index]?.marked=="marked"?
     <div className="palletAttempdedButtonQP mockTestTagsFont" 
     style={{}}
     ><div className="palletAttempdedButtonInnQP mockTestTagsFont"  style={{}}
     ></div><div className="mockTestSubTitleFont" style={{marginTop:"10px"}}>{index<10?"0"+(index+1):(index+1)}</div> <div className="mockTestSubTitleFont" style={{position:"relative",fontSize:"12px",marginTop:"12px",left:"-7px"}}>Marked & Answered</div> </div> :<div className="palletNotAttempdedButtonQP mockTestTagsFont" style={{}}>{index<10?"0"+(index+1):(index+1)} Not Visited</div>
     
     } 

     <div>
       <div style={{display:"flex",justifyContent:"space-between",padding:"0px",marginTop:"10px",fontSize:"12px"}}>
 <div style={{display:"flex",borderRadius:"5px",justifyContent:"space-between",gap:"5px",padding:"5px 5px",background:`${mockTestCard1Object?.queType?.bgColor?.color}`,
border:` ${mockTestCard1Object?.queType?.border?.borderWidth?.value+mockTestCard1Object?.queType?.border?.borderWidth?.resolution} ${mockTestCard1Object?.queType?.border?.borderType}  ${mockTestCard1Object?.queType?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${mockTestCard1Object?.queType?.borderRadius?.topLeft?.value}${mockTestCard1Object?.queType?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${mockTestCard1Object?.queType?.borderRadius?.topRight?.value}${mockTestCard1Object?.queType?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${mockTestCard1Object?.queType?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.queType?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${mockTestCard1Object?.queType?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.queType?.borderRadius?.bottomRight?.resolution}`,
}}>
  <div><BookOpenCheck    color={mockTestCard1Object?.queType?.iconColor?.color} size={15}/></div>
        <div  className="mockTestTagsFont"> {itemQuestion?.queType}</div>  
          </div>   
          
          <div style={{display:"flex",borderRadius:"5px",justifyContent:"space-between",gap:"5px",padding:"5px 5px",background:`${mockTestCard1Object?.difficultyLevel?.bgColor?.color}`,
border:` ${mockTestCard1Object?.difficultyLevel?.border?.borderWidth?.value+mockTestCard1Object?.difficultyLevel?.border?.borderWidth?.resolution} ${mockTestCard1Object?.difficultyLevel?.border?.borderType}  ${mockTestCard1Object?.difficultyLevel?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${mockTestCard1Object?.difficultyLevel?.borderRadius?.topLeft?.value}${mockTestCard1Object?.difficultyLevel?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${mockTestCard1Object?.difficultyLevel?.borderRadius?.topRight?.value}${mockTestCard1Object?.difficultyLevel?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${mockTestCard1Object?.difficultyLevel?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.difficultyLevel?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${mockTestCard1Object?.difficultyLevel?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.difficultyLevel?.borderRadius?.bottomRight?.resolution}`,
}}>
  <div><MessageCircleQuestion    color={mockTestCard1Object?.difficultyLevel?.iconColor?.color} size={15}/></div>
        <div  className="mockTestTagsFont"> {itemQuestion?.difficultyLevel}</div>  
          </div>
          
          </div>
            <div className="" style={{ display:"flex",borderRadius:"5px",justifyContent:"space-between" ,}}> 
          <div className="" style={{display:"flex",borderRadius:"5px",justifyContent:"space-between",padding:"5px",margin:"5px",marginLeft:"0px",gap:"5px"
          ,background:`${mockTestCard1Object?.questionTimer?.bgColor?.color}`,
border:` ${mockTestCard1Object?.questionTimer?.border?.borderWidth?.value+mockTestCard1Object?.questionTimer?.border?.borderWidth?.resolution} ${mockTestCard1Object?.questionTimer?.border?.borderType}  ${mockTestCard1Object?.questionTimer?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${mockTestCard1Object?.questionTimer?.borderRadius?.topLeft?.value}${mockTestCard1Object?.questionTimer?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${mockTestCard1Object?.questionTimer?.borderRadius?.topRight?.value}${mockTestCard1Object?.questionTimer?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${mockTestCard1Object?.questionTimer?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.questionTimer?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${mockTestCard1Object?.questionTimer?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.questionTimer?.borderRadius?.bottomRight?.resolution}`,
fontSize:"12px"}}> <Clock style={{position:"relative"}} 
  color={mockTestCard1Object?.questionTimer?.iconColor?.color} size={15}/> {formatTimeQue(getTimerByActiveID(itemQuestion?.ID))}</div>
           {itemQuestion?.enableDisplayMarks=="true"?<div style={{display:"flex",justifyContent:"space-between",gap:"10px",padding:"5px"}}>
 <div className="mockTestTagsFont" style={{display:"flex",borderRadius:"5px",justifyContent:"space-between",padding:"5px",background:`${mockTestCard1Object?.plusMarks?.bgColor?.color}`,
border:` ${mockTestCard1Object?.plusMarks?.border?.borderWidth?.value+mockTestCard1Object?.plusMarks?.border?.borderWidth?.resolution} ${mockTestCard1Object?.plusMarks?.border?.borderType}  ${mockTestCard1Object?.plusMarks?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${mockTestCard1Object?.plusMarks?.borderRadius?.topLeft?.value}${mockTestCard1Object?.plusMarks?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${mockTestCard1Object?.plusMarks?.borderRadius?.topRight?.value}${mockTestCard1Object?.plusMarks?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${mockTestCard1Object?.plusMarks?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.plusMarks?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${mockTestCard1Object?.plusMarks?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.plusMarks?.borderRadius?.bottomRight?.resolution}`,

  fontSize:"12px"
 }}>

       <Plus style={{position:"relative"}}   color={mockTestCard1Object?.plusMarks?.iconColor?.color} size={15}/>
          {itemQuestion?.marks}
          </div> <div className="mockTestTagsFont" style={{display:"flex",borderRadius:"5px",justifyContent:"space-between",padding:"5px",background:`${mockTestCard1Object?.negativeMarks?.bgColor?.color}`,
border:` ${mockTestCard1Object?.negativeMarks?.border?.borderWidth?.value+mockTestCard1Object?.negativeMarks?.border?.borderWidth?.resolution} ${mockTestCard1Object?.negativeMarks?.border?.borderType}  ${mockTestCard1Object?.negativeMarks?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${mockTestCard1Object?.negativeMarks?.borderRadius?.topLeft?.value}${mockTestCard1Object?.negativeMarks?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${mockTestCard1Object?.negativeMarks?.borderRadius?.topRight?.value}${mockTestCard1Object?.negativeMarks?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${mockTestCard1Object?.negativeMarks?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.negativeMarks?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${mockTestCard1Object?.negativeMarks?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.negativeMarks?.borderRadius?.bottomRight?.resolution}`,
fontSize:"12px"
          }}>
 <Minus style={{position:"relative"}}   color={mockTestCard1Object?.negativeMarks?.iconColor?.color} size={15}/>
            {itemQuestion?.negativeMarks}
          </div>   </div>:""}
     </div>
     </div>
     </div>
    
 

   
    <div className="" >
        <div className="mockTestButtonFont" style={{display:"flex",borderRadius:"5px",justifyContent:"space-between",gap:"5px",padding:"5px 5px",}}>
  Section: {indexSec+1} {item?.sectionName} </div>
       <div className=" mockTestTitleFont "  style={{fontSize:"19px",padding:"5px",fontWeight:"999",margin:"0px",display:"flex",
    justifyContent:"left",alignItems:"center",
    background:`${mockTestCard1Object?.questionName?.bgColor?.color}`,
border:` ${mockTestCard1Object?.questionName?.border?.borderWidth?.value+mockTestCard1Object?.questionName?.border?.borderWidth?.resolution} ${mockTestCard1Object?.questionName?.border?.borderType}  ${mockTestCard1Object?.questionName?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${mockTestCard1Object?.questionName?.borderRadius?.topLeft?.value}${mockTestCard1Object?.questionName?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${mockTestCard1Object?.questionName?.borderRadius?.topRight?.value}${mockTestCard1Object?.questionName?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${mockTestCard1Object?.questionName?.borderRadius?.bottomLeft?.value}${mockTestCard1Object?.questionName?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${mockTestCard1Object?.questionName?.borderRadius?.bottomRight?.value}${mockTestCard1Object?.questionName?.borderRadius?.bottomRight?.resolution}`,
}}> Que {index+1} : {itemQuestion?.queName} 
 </div><div style={{width:"300px"}}> 
   <QuestionRichContent contentType="instruction" queRichContents={itemQuestion?.queRichContent?.contents}/>
          </div>
          <div style={{padding:"5px"}} >
      {itemQuestion?.options?.map((option,index)=>(<>
       <div  style={{ }}>
      <div className="" style={{ display:"flex",borderRadius:"5px",justifyContent:"left" ,padding:"5px",margin:"5px",
    borderRadius:"5px",fontWeight:"999",fontWeight:"500",color:"#888",fontSize:"14px"}}>
     <div>  {index+1}: {option?.optionText}<div>
     {option?.optionImgS3?.success?<ImageFallFB  boxShadow={``}
                  src={option?.optionImgS3?.file?.file}
                  border={{}}
                  width={ 100
                  }
                  
                  borderRadius={{}
                  }/>:""
}</div>
   </div></div></div></>))}</div>
        </div>
       </div>
    </div> 
          </div>)):""}



      
      
       </div>))}

</div>
    
    </>)
}
export default MockTestQuestionPaper;